import React from "react";
import DocsWidget from "@/components/widgets/DocsWidget";
import NotesWidget from "@/components/widgets/NotesWidget";
import SelectScreeningStatus from "@/components/applications/SelectScreeningStatus";
import CheckListCard from "@/components/tasks/CheckListCard";
import WidgetContainer from "@/components/widgets/WidgetContainer";

const AuthorizationTab = () => {
  return (
    <div>
      <div className="p-3">
        <div className="row">
          <div className="col">
            {/* <WidgetContainer title="Todo Checklist"> */}
              <ReviewAuthCard />
              <CertifyAuthCard />
            {/* </WidgetContainer> */}
          </div>
          <div className="col col-4">
            <SelectScreeningStatus className="mb-3" />
            <hr />
            <NotesWidget />
            <DocsWidget />
          </div>
        </div>
      </div>
    </div>
  );
};

const ReviewAuthCard = () => (
  <CheckListCard
    title="Authorization Form Review"
    caption="Review that applicant has succesfully completed authorization form."
    checked
  >
    <button className="btn btn-primary">View authorization form</button>
  </CheckListCard>
);

const CertifyAuthCard = () => (
  <CheckListCard title="Has the applicant correctly completed the authorization form?">
    <button className="btn btn-success me-2">Yes</button>
    <button className="btn btn-danger">No</button>
  </CheckListCard>
);

AuthorizationTab.propTypes = {};

export default AuthorizationTab;
